@if (searchCriteria) {
  <div class="columns">
    <div class="column">
      @if (noResultsFound) {
        <section class="section">
          <div class="container">
            <div class="subtitle has-text-centered">
              <h2 class="has-text-weight-bold">
                No results found.
              </h2>
            </div>
          </div>
        </section>
      }
      @if (results && results.length > 0) {
        <div>
          <cdk-virtual-scroll-viewport itemSize="50" class="viewport">
            <table class="table is-fullwidth is-striped ">
              <thead>
                <tr role="row" class="is-selected">
                  @for (column of columns; track column) {
                    @if (column.display) {
                      <th class="table-header" [mcTableSorting]="config" [column]="column" title="{{column.title}}"
                        (sortChanged)="onChangeTable($event)" ngClass="{{column.className || ''}}">
                        <span> {{column.title}}</span>
                        @if (config && column.sort != undefined) {
                          <span class="sort is-text-centered">
                            @if (column.sort === '') {
                              <span>
                                <i class="fas fa-sort"></i>
                              </span>
                            }
                            @if (column.sort === 'desc') {
                              <span>
                                <i class="fas fa-sort-down"></i>
                              </span>
                            }
                            @if (column.sort === 'asc') {
                              <span>
                                <i class="fas fa-sort-up"></i>
                              </span>
                            }
                          </span>
                        }
                      </th>
                    }
                  }
                </tr>
              </thead>
              <tbody>
                @if (showFilterRow) {
                  <tr>
                    @for (column of columns; track column) {
                      <td>
                        @if (column.filtering) {
                          <input placeholder="{{column.filtering.placeholder}}"
                            [mcTableFiltering]="column.filtering"
                            class="form-control" (tableChanged)="onChangeTable(config)" />
                        }
                      </td>
                    }
                  </tr>
                }
                <ng-container *cdkVirtualFor="let row of rows">
                  <tr>
                    <td>
                      <a (click)="goToManageSlotReservation($event, row)">
                        <span class="has-text-weight-bold">
                          {{row.studyReservationId}}
                        </span>
                      </a>
                    </td>
                    <td>
                      <span>{{row.currentState}}</span>
                    </td>
                    <td>
                      <span> {{row.initials}} </span>
                    </td>
                    <td>
                      <span>{{row.slotGroupDescription}}</span>
                    </td>
                    <td>
                      <span>{{row.currentStateDate | date:'MM/dd/yyyy'}}</span>
                    </td>
                    <td>
                      <span>{{row.expirationDate | date:'MM/dd/yyyy'}}</span>
                    </td>
                    <td>
                      <span>{{row.treatingLocation}}</span>
                    </td>
                    <td>
                      <span>{{row.siteContact}}</span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </cdk-virtual-scroll-viewport>
        </div>
      }
    </div>
  </div>
}



